import PeopleModal from './PeopleModal';

export default (props) => {
  return <PeopleModal {...props} />;
};
